import React from "react";

export function SuccessMessage({ className = '', children }) {
  return (
    <div className={`p-4 rounded mb-2 bg-green-100 w-full max-w-none shadow-sm flex justify-between ${className}`}>
      <p>
        {children}
      </p>
      {/*<X className="inline-block ml-auto cursor-pointer" size={23} onClick={() => { setClosed(true); }} />*/}
    </div>
  );
}
